import { useActiveLeagueContext } from '../context/ActiveLeagueContext';

/**
 * @typedef {Object} ActiveLeagueContextValue
 * @property {Object|null} activeLeague - The currently active league object.
 * @property {Function} setActiveLeague - Function to set the active league (may involve navigation).
 * @property {number|null} season - Current season number for the league.
 * @property {boolean} isLoading - Whether the league data is currently loading.
 * @property {Error|null} error - Any error that occurred while fetching league data.
 */

/**
 * Custom hook to access the active league context.
 * Provides the active league, a setter, loading state, and error state.
 * 
 * @returns {ActiveLeagueContextValue}
 * @throws {Error} If used outside of an ActiveLeagueProvider.
 */
export const useActiveLeague = () => {
  return useActiveLeagueContext();
};
